
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Dashboard from "./components/Dashboard";
import CreateGameModal from "./components/CreateGameModal";
import Header from "./components/Header";

function App() {
  const [games, setGames] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check if user is authenticated on page load
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);
  const handleLogout = () => {
    localStorage.removeItem("token");  // Remove token on logout
    setIsAuthenticated(false);  // Update the authentication state
  };

  const addGame = (game) => setGames([...games, game]);

  if (loading) {
    return <div>Loading...</div>;
  }

  

  return (
    <Router>
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {/* Show Header only when authenticated */}
        {isAuthenticated && <Header onLogout={handleLogout} />}

        
        <div className="min-h-screen bg-gray-200 flex flex-col items-center justify-center">
          <Routes>
            <Route path="/" element={<Navigate to="/signin" />} />
            <Route
              path="/signin"
              element={<SignIn onLogin={() => setIsAuthenticated(true)} />}
            />
            <Route path="/signup" element={<SignUp />} />
            <Route
              path="/dashboard"
              element={
                isAuthenticated ? (
                  <>
                    <Dashboard games={games} onAdd={() => setShowModal(true)} />
                    {showModal && <CreateGameModal onClose={() => setShowModal(false)} onSave={addGame} />}
                  </>
                ) : (
                  <Navigate to="/signin" />
                )
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
